/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import { orgTypes } from '@hbrisk/sp3-risk-model-support/orgs/orgTypes.js';
import BasicReduxFormSelectMenu from '#components/support/forms/SelectMenus/BasicReduxFormSelectMenu/index.jsx';
import { RenderInput } from '#components/support/forms/utility/index.js';

const items = orgTypes.map(({ value, label }) => ({ id: value, name: label, value }));

const OrgTypeSelectMenu = (): Element<typeof BasicReduxFormSelectMenu> => (
  <BasicReduxFormSelectMenu
    items={items}
    id="orgType"
    name="orgType"
    inputClassName={classNames('custom-select', 'org-type-select')}
    component={RenderInput}
  />
);

export default OrgTypeSelectMenu;
